<nav [ngClass]="{ open: open }" [hidden]="!featureService.disableNewNavigation && area === 'Network'">
  @if (area === 'Support' || area === 'Search' || area === 'Super') {
    <div class="title">
      {{ pageArea }}
    </div>
  }
  @if (
    area === 'Organization' &&
    !billingStatusInvalid &&
    ((billingEnabledService.billingEnabled && tenants.length === 1) || !authorizationService.canListTenants())
    ) {
    <div
      class="title"
      >
      Org Management
    </div>
  }
  <div
    (click)="toggleLock()"
    [ngClass]="{ locked: menuService.locked }"
    class="lock"
    id="MenuLock"
    title="Lock Menu Open"
  ></div>

  @if (area === 'Network' && authorizationService.canListNetworks()) {
    <div
      (clickOutside)="closeNetworkList()"
      class="networksArea"
      >
      <div class="networks">
        <div (click)="toggleList($event)" class="currentNetwork" id="currentNetwork">
          {{ currentNetwork.name }}
        </div>
        <div [ngClass]="{ opened: isOpened }" class="shadow" id="Networks">
          <div class="row">
            <div (click)="toggleList($event)" class="currentNetwork">
              {{ currentNetwork.name }}
            </div>
          </div>
          <div id="ListArea">
            <div class="search row">
              <input
                (click)="stopProp($event)"
                [(ngModel)]="filterString"
                id="SearchNetworks"
                placeholder="Type to Filter"
                type="text"
                />
            </div>
            <div class="headerNetworkList row">
              @for (networkModel of allNetworks | tableSearch: filterString | sortby: 'name'; track networkModel) {
                <div
                  (click)="setNetwork(networkModel)"
                  class="selectNetwork row"
                  >
                  <div class="status s{{ networkModel.status }}" id="nStatList{{ networkModel.id }}">
                    <div class="anim5"></div>
                  </div>
                  {{ networkModel.name }}
                </div>
              }
              @if (authorizationService.canCreateNetworks()) {
                <div
                  (click)="addNetwork()"
                  class="item row"
                  id="AddNetworkButton"
                  >
                  <div class="icon append icon-BigSoftPlus"></div>
                  <div class="content">Add a New Network</div>
                </div>
              }
            </div>
            <!--          <div *ngIf="!featureService.experimentalFeatures" id="ManageNetworkButton" class="navItem" routerLink="/networks">Manage Networks</div>-->
            <div class="navItem" id="ManageNetworkButton" routerLink="/networks">Manage Networks</div>
          </div>
        </div>
      </div>
    </div>
  }
  @if (
    area === 'Organization' &&
    (!billingEnabledService.billingEnabled || tenants.length > 1) &&
    authorizationService.canListTenants() &&
    (!this.isSelfService || authorizationService.isSupportUser)
    ) {
    <div
      (clickOutside)="closeTenantList()"
      class="tenantArea"
      >
      <div class="tenants">
        <div (click)="toggleListTenant($event)" class="currentTenant" id="currentTenant">
          {{ currentTenant.name }}
        </div>
        <div [ngClass]="{ opened: isOpenedTenant }" class="shadow" id="Tenants">
          <div class="row">
            <div (click)="toggleListTenant($event)" class="currentTenant">
              {{ currentTenant.name }}
            </div>
          </div>
          <div id="ListArea">
            <div class="search row">
              <input
                (click)="stopProp($event)"
                [(ngModel)]="filterString"
                id="SearchTenants"
                placeholder="Type to Filter"
                type="text"
                />
            </div>
            <div class="headerTenantList row">
              @for (tenantModel of tenants | tableSearch: filterString | sortby: 'name'; track tenantModel) {
                <div
                  (click)="setTenant(tenantModel)"
                  [ngClass]="{ selected: currentTenant.id === tenantModel.id }"
                  class="selectNetwork row"
                  >
                  <div class="orgStatus s300" id="nStatList{{ tenantModel.id }}">
                    <div class="anim5"></div>
                  </div>
                  {{ tenantModel.name }}
                </div>
              }
              @if (authorizationService.canCreateTenant()) {
                <div
                  (click)="addTenant()"
                  class="item row"
                  id="AddTenantButton"
                  >
                  <div class="icon append icon-BigSoftPlus"></div>
                  <div class="content">Add a New Organization</div>
                </div>
              }
            </div>
            <div [routerLink]="Organizations" class="navItem" id="ManageTenantsButtons">
              Manage Organizations
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  <div [ngClass]="{ open: area === 'Network' }" class="navArea" id="NetworkNavigation">
    <div [ngClass]="{ logoEnabled: brandingModeService.logosAvailable }" class="navList menuscroll">
      @if (!isZiti) {
        <div [ngClass]="{ selected: url === '/main' }" class="navButton" routerLink="/main/">
          <div class="iconArea rippler" id="NetworkDashboard">
            <div class="image icon-Icon_Dash"></div>
          </div>
          <div class="label">Network Dashboard</div>
        </div>
      }

      @if (isZiti) {
        <div
          (click)="handleClickEventNav($event, '/zdashboard/')"
          [ngClass]="{ selected: url === '/zdashboard', disabled: disableMainNav }"
          [title]="disableMainNav ? disabledToolTip : ''"
          class="navButton"
          >
          <div class="iconArea rippler" id="NetworkDashboardV7">
            <div class="image icon-Icon_Dash"></div>
          </div>
          <div class="label">Network Dashboard</div>
        </div>
      }

      @if (!isZiti) {
        <div
          [ngClass]="{ selected: url === Appwans || url === Services }"
          [routerLink]="Services"
          class="navButton"
          >
          @if (authorizationService.canListAppWans || authorizationService.canListServices) {
            <div
              class="iconArea rippler"
              id="ManageAppWANS"
              >
              <div class="image icon-appwans"></div>
            </div>
          }
          <div class="label">Services and AppWANs</div>
        </div>
      }

      @if (isZiti) {
        <div
          (click)="handleClickEventNav($event, Ziti_AppWans)"
          [ngClass]="{ selected: url === Ziti_AppWans, disabled: disableMainNav }"
          [title]="disableMainNav ? disabledToolTip : ''"
          class="navButton ziti-appwans-nav"
          >
          <div class="iconArea rippler" id="ManageAppWANS">
            <div class="image icon-appwans"></div>
          </div>
          <div class="label">AppWANs</div>
        </div>
      }

      @if (isZiti) {
        <div
          (click)="handleClickEventNav($event, Ziti_Services)"
          [ngClass]="{ selected: url === Ziti_Services, disabled: disableMainNav }"
          [title]="disableMainNav ? disabledToolTip : ''"
          class="navButton ziti-services-nav"
          >
          <div class="iconArea rippler" id="ManageServices">
            <div class="image icon-services"></div>
          </div>
          <div class="label">Services</div>
        </div>
      }

      @if (isZiti) {
        <div
          (click)="handleClickEventNav($event, Ziti_Endpoints)"
          [ngClass]="{ selected: url === Ziti_Endpoints, disabled: disableMainNav }"
          [title]="disableMainNav ? disabledToolTip : ''"
          class="navButton ziti-endpoints-nav"
          >
          <div class="iconArea rippler" id="ManageZitiEndpoints">
            <div class="image icon-Icon_CL"></div>
          </div>
          <div class="label">Endpoints</div>
        </div>
      }
      @if (isZiti) {
        <div
          (click)="handleClickEventNav($event, Edge_Routers)"
                [ngClass]="{
                    selected:
                        url === Edge_Routers || url === '/v7/policies' || url === Ziti_Service_Edge_Router_Policies,
                    disabled: disableMainNav
                }"
          [title]="disableMainNav ? disabledToolTip : ''"
          class="navButton"
          >
          <div class="iconArea rippler" id="ManageRouters">
            <div class="image icon-routers"></div>
          </div>
          <div class="label">Edge Routers</div>
        </div>
      }
      @if (isZiti && authorizationService.canListPostureChecks() && networkCanHavePostureChecks) {
        <div
          (click)="handleClickEventNav($event, Posture_Checks)"
          [ngClass]="{ selected: url === Posture_Checks, disabled: disableMainNav }"
          class="navButton"
          >
          <div class="iconArea rippler" id="ManagePostureChecks">
            <div class="image icon-posturechecks"></div>
          </div>
          <div class="label">Posture Checks</div>
        </div>
      }

      @if (
        authorizationService.canListNetworks() &&
        authorizationService.canReadAlarms() &&
        !authorizationService.canReadElasticSearch()
        ) {
        <div
          [ngClass]="{ selected: url === Management_Events || url === Alarms }"
          [routerLink]="Alarms"
          class="navButton"
          >
          <div class="iconArea rippler" id="NetworkAlarms">
            <div class="image icon-Icon_Events"></div>
          </div>
          <div class="label">Network Alarms</div>
        </div>
      }

      @if (!isZiti) {
        <div
                [ngClass]="{
                    selected: url === Gateways || url === Clients || url === Azure_Virtual_Wan_Sites || url === Groups
                }"
          [routerLink]="Gateways"
          class="navButton"
          >
          @if (authorizationService.canListEndpoints || authorizationService.canListGroups) {
            <div
              class="iconArea rippler"
              id="ManageEndpoints"
              >
              <div class="image icon-endpoints"></div>
            </div>
          }
          <div class="label">Endpoints</div>
        </div>
      }
      @if (azureEnabled) {
        <div
          [ngClass]="{ selected: url === '/virtualwans' }"
          class="navButton"
          routerLink="/virtualwans/"
          >
          <div class="iconArea rippler" id="ManageAVWS">
            <div class="image icon-virtualwans"></div>
          </div>
          <div class="label">Azure Virtual WANs</div>
        </div>
      }
      @if (
        (authorizationService.canListCAs() ||
        authorizationService.canListAuthPolicies() ||
        authorizationService.canListJwtSigners()) &&
        isZiti
        ) {
        <div
          (click)="handleClickEventNav($event, Ziti_Certificate_Authorities)"
                [ngClass]="{
                    selected: url === Ziti_Certificate_Authorities || url === Auth_Policies || url === JWT_Signers,
                    disabled: disableMainNav
                }"
          [title]="disableMainNav ? disabledToolTip : ''"
          class="navButton"
          >
          <div class="iconArea rippler" id="ManageCAs">
            <div class="image icon-CAs"></div>
          </div>
          <div class="label">Authentication</div>
        </div>
      }
      @if (canManageSubscriptions() && !this.isSelfServiceTeamsTier) {
        <div
                [ngClass]="{
                    selected:
                        url === Subscriptions_VWAN ||
                        url === Subscriptions_AAD ||
                        url === Subscriptions_AD ||
                        url === Subscriptions_VIRTUALWAN,
                    disabled: disableMainNav
                }"
          [routerLink]="Subscriptions_VWAN"
          class="navButton"
          >
          <div class="iconArea rippler" id="ManageSubscriptions">
            <div class="image icon-integrations"></div>
          </div>
          <div class="label">Integrations</div>
        </div>
      }

      @if (
        authorizationService.canListNetworks() &&
        authorizationService.canReadElasticSearch() &&
        apiService.getNetworkVersion(currentNetwork) > 6
        ) {
        <div
          [ngClass]="{ selected: url === Metrics, disabled: disableMainNav }"
          [routerLink]="Metrics"
          [title]="disableMainNav ? disabledToolTip : ''"
          class="navButton"
          >
          <div class="iconArea rippler" id="Metrics">
            <div class="image icon-AnalyticsReports"></div>
          </div>
          <div class="label">Metrics</div>
        </div>
      }

      @if (authorizationService.canListNetworks() && authorizationService.canReadElasticSearch()) {
        <div
                [ngClass]="{
                    selected: url === Management_Events || url === Alarms,
                    disabled: disableMainNav && !provisioning
                }"
          [routerLink]="Management_Events"
          [title]="disableMainNav ? disabledToolTip : ''"
          class="navButton"
          >
          <div class="iconArea rippler" id="NetworkEvents">
            <div class="image icon-Icon_Events"></div>
          </div>
          <div class="label">Events</div>
        </div>
      }

      @if (authorizationService.canListCAs() && zitiEnabledService.zitiEnabled) {
        <div
          (click)="handleClickEventNav($event, Certificate_Authorities)"
          [ngClass]="{ selected: url === Certificate_Authorities, disabled: disableMainNav }"
          [title]="disableMainNav ? disabledToolTip : ''"
          class="navButton"
          >
          <div class="iconArea rippler" id="ManageCAs">
            <div class="image icon-CAs"></div>
          </div>
          <div class="label">Certificate Authorities</div>
        </div>
      }

      <div
                [ngClass]="{
                    selected: url === '/networks' || url === '/network-groups' || url === '/networks-combined'
                }"
        class="navButton"
        routerLink="/networks-combined"
        >
        <div class="iconArea rippler" id="ManageNetworks">
          <div class="image icon-ManageNetworks">
            @if (upgradeableNetworks) {
              <span class="counterBadge">{{ upgradeableNetworks }}</span>
            }
          </div>
        </div>
        <div class="label">Manage Networks</div>
      </div>

      <div class="nav-details">
        @if (brandingModeService.logosAvailable) {
          <div
            [ngClass]="{ dark: brandingService.darkModeEnabled }"
            class="navlogo"
          ></div>
        }
        @if (currentNetwork.id) {
          <div class="versionInfo">
            <div class="networkInfo" id="NetworkVersion">
              Network Version: {{ majorVersionNumber }}.{{ minorVersionNumber }}.{{ patchVersionNumber }}
            </div>
          </div>
        }
      </div>
    </div>
  </div>
  <div [ngClass]="{ open: area === 'Organization' }" class="navArea" id="OrganizationNavigation">
    <div [ngClass]="{ logoEnabled: brandingModeService.logosAvailable }" class="navList">
      @if (
        !billingStatusInvalid &&
        (authorizationService.canListUserIdentities() || authorizationService.canListInvitations())
        ) {
        <div
          [ngClass]="{ selected: url === Users || url === Manage_Invitations }"
          [routerLink]="Users"
          class="navButton"
          >
          <div class="iconArea rippler" id="ManageUsers">
            <div class="image icon-ManageUsers"></div>
          </div>
          <div class="label">Users</div>
        </div>
      }
      @if (!billingStatusInvalid && authorizationService.canListApiAccountIdentities()) {
        <div
          [ngClass]="{ selected: url === Tokens }"
          [routerLink]="Tokens"
          class="navButton"
          >
          <div class="iconArea rippler" id="ManageAPIAccounts">
            <div class="image icon-ManageAPIAccounts"></div>
          </div>
          <div class="label">API Accounts</div>
        </div>
      }
      @if (authorizationService.canListOrganizations()) {
        <div
          [ngClass]="{ selected: url === Stored_Secrets }"
          [routerLink]="Stored_Secrets"
          class="navButton"
          >
          <div class="iconArea rippler" id="StoredSecrets">
            <div class="image icon-posturechecks"></div>
          </div>
          <div class="label">Stored Secrets</div>
        </div>
      }
      @if (authorizationService.canListOrganizations()) {
        <div
          [ngClass]="{ selected: url === Customers }"
          [routerLink]="Customers"
          class="navButton"
          >
          <div class="iconArea rippler" id="Customers">
            <div class="image icon-customer"></div>
          </div>
          <div class="label">Customers</div>
        </div>
      }
      @if (!billingStatusInvalid && featureService.experimentalFeatures) {
        <div
          [ngClass]="{ selected: url === '/roles' }"
          class="navButton"
          routerLink="/roles/"
          >
          <div class="iconArea rippler" id="ManageRoles">
            <div class="image icon-Manage-Roles"></div>
          </div>
          <div class="label">Roles & Permissions</div>
        </div>
      }
      <!-- TODO updating billing auth -->

      @if (authorizationService.canViewPaymentProfile() && selfServiceBilling) {
        <div
          [ngClass]="{ selected: url === Billing }"
          [routerLink]="Billing"
          class="navButton"
          >
          <div class="iconArea rippler" id="BillingDashboard">
            <div class="image icon-ManageBilling"></div>
          </div>
          <div class="label">Billing Dashboard</div>
        </div>
      }
      @if (!billingStatusInvalid && authorizationService.canReadElasticSearch(currentOrg.getId())) {
        <div
            [ngClass]="{
                selected:
                    url === Resource_Usage ||
                    url === Daily_Stats ||
                    url === Network_Group_Summary ||
                    url === 'daily-endpoint-utilization'
            }"
          [routerLink]="Network_Group_Summary"
          class="navButton"
          >
          <div class="iconArea rippler" id="ReportingAnalytics">
            <div class="image icon-AnalyticsReports"></div>
          </div>
          <div class="label">Reporting And Analytics</div>
        </div>
      }
      @if (authorizationService.canViewPaymentProfile() && enterpriseBilling) {
        <div
                [ngClass]="{
                    selected:
                        url === Payment_Profile ||
                        url === Account_Details ||
                        url === Billing_Subscriptions ||
                        url === Billing_Subscription_Overages ||
                        url === Billing_Subscription_Usage ||
                        url === Billing_Subscription_Usage_Report ||
                        url === Billing_Subscription_Invoices
                }"
          [routerLink]="Payment_Profile"
          class="navButton"
          >
          <div class="iconArea rippler" id="BillingManagement">
            <div class="image icon-ManageBilling"></div>
          </div>
          <div class="label">Billing Management</div>
        </div>
      }
      @if (
        !billingStatusInvalid &&
        ((currentTenant && authorizationService.canUpdateTenant(currentTenant.id)) ||
        authorizationService.canUpdateColors() ||
        authorizationService.canDeleteColors() ||
        authorizationService.canUpdateLogos() ||
        authorizationService.canDeleteLogos())
        ) {
        <div
          [ngClass]="{ selected: url === Settings }"
          [routerLink]="Settings"
          class="navButton"
          >
          <div class="iconArea rippler" id="OrganizationalSettings">
            <div class="image icon-OrgSettings"></div>
          </div>
          <div class="label">Organizational Settings</div>
        </div>
      }
      @if (
        (!billingEnabledService.billingEnabled || tenants.length > 1) &&
        authorizationService.canListTenants() &&
        (!this.isSelfService || authorizationService.isSupportUser)
        ) {
        <div
          [ngClass]="{ selected: url === Organizations }"
          [routerLink]="Organizations"
          class="navButton"
          >
          <div class="iconArea rippler" id="ManageOrganizations">
            <div class="image icon-ManageOrg"></div>
          </div>
          <div class="label">Manage Organizations</div>
        </div>
      }
      @if (
        (!billingEnabledService.billingEnabled || tenants.length > 1) &&
        authorizationService.canListTenants() &&
        (!this.isSelfService || authorizationService.isSupportUser)
        ) {
        <div
          [ngClass]="{ selected: url === Oidc_Audiences }"
          [routerLink]="Oidc_Audiences"
          class="navButton"
          >
          <div class="iconArea rippler" id="ManageOidcAudiences">
            <div class="image icon-ManageOidcAudience"></div>
          </div>
          <div class="label">Manage Oidc Audiences</div>
        </div>
      }
    </div>
    @if (brandingModeService.logosAvailable) {
      <div
        [ngClass]="{ dark: brandingService.darkModeEnabled }"
        class="navlogo"
      ></div>
    }
  </div>
  <div [ngClass]="{ open: area === 'Super' }" class="navArea" id="SuperNavigation">
    <div [ngClass]="{ logoEnabled: brandingModeService.logosAvailable }" class="navList">
      <div [ngClass]="{ selected: url === User }" [routerLink]="User" class="navButton">
        <div class="iconArea rippler" id="ManageUser">
          <div class="image icon-ManageUsers"></div>
        </div>
        <div class="label">Manage Users</div>
      </div>
    </div>
    @if (brandingModeService.logosAvailable) {
      <div
        [ngClass]="{ dark: brandingService.darkModeEnabled }"
        class="navlogo"
      ></div>
    }
    <div class="versionInfo">
      <div id="BuildTime">{{ version?.buildTime }}</div>
    </div>
  </div>
  <div [ngClass]="{ open: area === 'Support' }" class="navArea" id="SupportNavigation">
    <div [ngClass]="{ logoEnabled: brandingModeService.logosAvailable }" class="navList">
      <div (click)="openHub()" class="navButton">
        <div class="iconArea rippler" id="SupportHub">
          <div class="image icon-hub"></div>
        </div>
        <div class="label">Support Hub</div>
      </div>
      @if (isSelfServiceTeamsTier === false && !environment.hideSubmitTicket) {
        <div (click)="openTicket()" class="navButton">
          <div class="iconArea rippler" id="SubmitTicket">
            <div class="image icon-Ticket"></div>
          </div>
          <div class="label">Submit A Ticket</div>
        </div>
      }

      <div (click)="openSupport()" class="navButton">
        <div class="iconArea rippler" id="Support">
          <div class="image icon-InlineHelp"></div>
        </div>
        <div class="label">Inline Help</div>
      </div>
      @if (!billingStatusInvalid) {
        <div (click)="openTour()" class="navButton">
          <div class="iconArea rippler" id="ConsoleTour">
            <div class="image icon-tour"></div>
          </div>
          <div class="label">Console Tour</div>
        </div>
      }
      @if (!isZiti) {
        <div (click)="openPageTour()" class="navButton">
          <div class="iconArea rippler" id="PageTour">
            <div class="image icon-PageTour"></div>
          </div>
          <div class="label">Page Tour</div>
        </div>
      }
      @if (!billingStatusInvalid) {
        <div (click)="gotoReleaseNotes()" class="navButton">
          <div class="iconArea rippler">
            <div class="image icon-WhatsNew"></div>
          </div>
          <div class="label">What's New</div>
        </div>
      }
      @if (!billingStatusInvalid && showGettingStarted) {
        <div
          [ngClass]="{ selected: url === Getting_Started }"
          [routerLink]="Getting_Started"
          class="navButton getting-started"
          >
          <div class="iconArea rippler">
            <div class="image icon-QuickStart"></div>
          </div>
          <div class="label">Getting Started</div>
        </div>
      }
    </div>
    @if (brandingModeService.logosAvailable) {
      <div
        [ngClass]="{ dark: brandingService.darkModeEnabled }"
        class="navlogo"
      ></div>
    }
    <div class="versionInfo">
      <div id="BuildTime">{{ version?.buildTime }}</div>
    </div>
  </div>
  <div [ngClass]="{ open: area === 'Search' }" class="navArea" id="SearchNavigation">Search</div>
</nav>
